"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Content = _interopRequireDefault(require("../common/Content"));

var _TopicLike = _interopRequireDefault(require("../topic-list-view/TopicLike"));

var _axios = _interopRequireDefault(require("axios"));

var _LikedUsers = _interopRequireDefault(require("../topic-list-view/LikedUsers"));

var _TopicMore = _interopRequireDefault(require("../topic-list-view/TopicMore"));

var _editor = _interopRequireDefault(require("../editor"));

var _TopicPublicTags = _interopRequireDefault(require("../topic-list-view/TopicPublicTags"));

var _permissions = require("../utils/permissions");

var _contentType = require("@insided/shared/utils/contentType");

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ArticleTopicView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ArticleTopicView, _Component);

  var _super = _createSuper(ArticleTopicView);

  function ArticleTopicView() {
    var _this;

    (0, _classCallCheck2.default)(this, ArticleTopicView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "content", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "canUserEditPost", (0, _permissions.canUserEditPost)() && !_this.props.isPreview);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: _this.props.topic.content,
      isCurrentUserLiked: !!_this.props.currentUser && _this.props.currentUser.id !== null && _this.props.topic.likedBy.includes(_this.props.currentUser.id.toString()),
      likedUsers: {},
      showEditor: false,
      isLoading: false,
      editorErrors: [],
      hideFirstPost: _this.props.currentPage > 1,
      tags: _this.props.topic.tags,
      anonymousLikesCount: 0
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleLikeStatus", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var event;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.currentUser) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!(_this.props.currentUser.id === null)) {
                _context.next = 6;
                break;
              }

              event = new CustomEvent('GuestUserAction');
              window.dispatchEvent(event);
              return _context.abrupt("return");

            case 6:
              if (!_this.state.isCurrentUserLiked) {
                _context.next = 13;
                break;
              }

              delete _this.state.likedUsers[_this.props.currentUser.id];

              _this.setState(function (prevState) {
                return {
                  likedUsers: prevState.likedUsers,
                  isCurrentUserLiked: false
                };
              });

              _context.next = 11;
              return _axios.default.post("/community/api/articles/".concat(_this.props.topic.id, "/unlike"), {
                unlikedBy: _this.props.currentUser.id
              });

            case 11:
              _context.next = 16;
              break;

            case 13:
              _this.setState(function (prevState) {
                var _this$props, _this$props$currentUs;

                return {
                  likedUsers: _objectSpread(_objectSpread({}, prevState.likedUsers), ((_this$props = _this.props) === null || _this$props === void 0 ? void 0 : (_this$props$currentUs = _this$props.currentUser) === null || _this$props$currentUs === void 0 ? void 0 : _this$props$currentUs.id) !== undefined ? (0, _defineProperty2.default)({}, _this.props.currentUser.id, _this.props.currentUser) : {}),
                  isCurrentUserLiked: true
                };
              });

              _context.next = 16;
              return _axios.default.post("/community/api/articles/".concat(_this.props.topic.id, "/like"), {
                likedBy: _this.props.currentUser.id
              });

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeOpeningPost", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _e$response, _e$response$data, _e$response$data$erro;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 1;
              _context2.next = 4;
              return _axios.default.post("/community/api/articles/".concat(_this.props.topic.id, "/editContent"), {
                content: _this.content
              });

            case 4:
              _this.setState({
                showEditor: false,
                content: _this.content,
                isLoading: false
              });

              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);

              _this.setState({
                isLoading: false
              });

              if ((_e$response = _context2.t0.response) !== null && _e$response !== void 0 && (_e$response$data = _e$response.data) !== null && _e$response$data !== void 0 && (_e$response$data$erro = _e$response$data.errors) !== null && _e$response$data$erro !== void 0 && _e$response$data$erro.content) {
                _this.setState({
                  editorErrors: [{
                    category: 'Forum',
                    phrase: 'validation.text.required'
                  }]
                });
              } else {
                _this.setState({
                  editorErrors: [{
                    category: 'Forum',
                    phrase: "Something's gone wrong"
                  }]
                });
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 7]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var topic, totalLikes, res, responseData;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              topic = _this.props.topic;
              totalLikes = topic.likedBy.length;

              if (!totalLikes) {
                _context3.next = 9;
                break;
              }

              _context3.next = 5;
              return _axios.default.post('/member/getUsersById', {
                ids: topic.likedBy
              });

            case 5:
              res = _context3.sent;
              responseData = Object.keys(res.data);

              _this.setState({
                likedUsers: res.data
              });

              if (responseData.length < totalLikes) {
                _this.setState({
                  anonymousLikesCount: totalLikes - responseData.length
                });
              }

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    return _this;
  }

  (0, _createClass2.default)(ArticleTopicView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          topic = _this$props2.topic,
          currentPage = _this$props2.currentPage,
          isPreview = _this$props2.isPreview;
      var _this$state = this.state,
          content = _this$state.content,
          isCurrentUserLiked = _this$state.isCurrentUserLiked,
          likedUsers = _this$state.likedUsers,
          tags = _this$state.tags,
          showEditor = _this$state.showEditor,
          isLoading = _this$state.isLoading,
          editorErrors = _this$state.editorErrors,
          hideFirstPost = _this$state.hideFirstPost,
          anonymousLikesCount = _this$state.anonymousLikesCount;

      var _ref5 = topic || {},
          author = _ref5.author;

      var _ref6 = author || {},
          reputation = _ref6.reputation;

      var _ref7 = reputation !== null && reputation !== void 0 ? reputation : {},
          repliesMade = _ref7.repliesMade;

      var totalLikes = Object.keys(likedUsers).length + anonymousLikesCount;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "post box__pad qa-topic-post-box post--odd js-toggle-target ".concat(hideFirstPost ? 'is-hidden' : '')
      }, (0, _preact.h)("div", {
        className: "post__user__info"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: _objectSpread(_objectSpread({}, author), {
          name: author === null || author === void 0 ? void 0 : author.username
        }),
        extraClass: "avatar avatar--responsive",
        showRank: true
      })), (0, _preact.h)("div", {
        className: "post__user__meta"
      }, (0, _preact.h)("ul", {
        className: (0, _classnames.default)('list', 'list--dot-seperated', 'text--meta')
      }, (0, _preact.h)("li", null, (0, _preact.h)("div", {
        className: "group--inline"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/member/profile?mid=".concat(author.id))
      }, author.username))), !!(repliesMade && repliesMade > 0) && (0, _preact.h)("li", {
        className: "is-hidden-S"
      }, (0, _preact.h)(_phrase.default, {
        p: "topic.meta.post.reply",
        count: {
          n: repliesMade.toString()
        }
      })))), (0, _preact.h)("div", null, showEditor ? (0, _preact.h)("div", {
        className: "post__content post__edit"
      }, (0, _preact.h)(_editor.default, {
        data: this.state.content,
        attachments: [],
        canHavePoll: false,
        isLoading: isLoading,
        errors: editorErrors,
        onSubmit: this.onChangeOpeningPost,
        onCancel: function onCancel() {
          return _this2.setState({
            showEditor: false
          });
        },
        onChange: function onChange(content) {
          _this2.content = content;
        },
        profile: "openingPost"
      })) : (0, _preact.h)(_Content.default, {
        content: content !== null && content !== void 0 ? content : '',
        className: (0, _classnames.default)('post__content', 'qa-topic-post-content', 'post__content--new-editor')
      })), (0, _preact.h)(_TopicPublicTags.default, {
        topicId: topic.id,
        contentType: _contentType.CONTENT_TYPE_ARTICLE,
        tags: tags,
        canUserEdit: this.canUserEditPost,
        onChange: function onChange(newTags) {
          return _this2.setState({
            tags: newTags
          });
        }
      }), !isPreview && totalLikes ? (0, _preact.h)(_LikedUsers.default, {
        likedUsers: Object.keys(likedUsers).map(function (id) {
          return likedUsers[id];
        }),
        previewCount: 3,
        isCurrentUserLiked: isCurrentUserLiked,
        anonymousLikesCount: anonymousLikesCount
      }) : null, !isPreview ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('post__footer', 'post__footer-wrapper', 'qa-topic-post-footer')
      }, (0, _preact.h)(_TopicLike.default, {
        className: "".concat(isCurrentUserLiked ? 'active' : ''),
        onClick: this.toggleLikeStatus
      }), this.canUserEditPost ? (0, _preact.h)(_TopicMore.default, null, (0, _preact.h)("li", {
        onClick: function onClick() {
          return _this2.setState({
            showEditor: true
          });
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "Edit"
      }))) : null) : null), currentPage > 1 ? (0, _preact.h)("a", {
        href: "#",
        className: "first-post__close",
        onClick: function onClick() {
          return _this2.setState({
            hideFirstPost: !hideFirstPost
          });
        }
      }, hideFirstPost ? (0, _preact.h)(_phrase.default, {
        p: "showFirstpost.message"
      }) : (0, _preact.h)(_phrase.default, {
        p: "hideFirstpost.message"
      })) : null);
    }
  }]);
  return ArticleTopicView;
}(_preact.Component);

var _default = ArticleTopicView;
exports.default = _default;